import React from 'react';
import { Icon } from './Icon.js';
export const IconLessThan = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.53003 11.1162L1.86011 12L3.53003 12.8838L19.9978 21.6016V19.3389L6.1355 12L19.9978 4.66016V2.39746L3.53003 11.1162Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconLessThan.js.map